import { SET_IS_NEW_RECORD } from '../actionTypes';
import { createProposalModalActions } from '../reducer';

export default (value) => createProposalModalActions[SET_IS_NEW_RECORD](value);
